const axiosConfig: {
    base_url: {
        development: string
        production: string
        test: string
    }
    request_timeout: number
} = {
    /**
     * api请求基础路径
     */
    base_url: {
        // 开发环境接口前缀
        development: '/api',

        // 打包生产环境接口前缀
        production: 'https://api.hxjf9999.com',

        // 打包测试环境接口前缀
        test: 'https://api.test.hxjf9999.com'
    },

    /**
     * 接口请求超时时间
     */
    request_timeout: 6000000,
}

export { axiosConfig }
